// Function index:
//   RulesPauseBannerHandle — controller interface returned by mountRulesPauseBanner.
//   mountRulesPauseBanner() — wire the pause banner DOM nodes; returns a handle.
//
// Shown only while the party is paused for a rules discussion. Purely
// display + a read of current state for client-side action gating (Task 11)
// — the server enforces regardless via blockedByRulesPause and the
// executeTool guard.

export interface RulesPauseBannerHandle {
  // Set the current topic (or null to hide the banner).
  setPaused(topic: string | null): void;
  // Whether the party is currently paused. Consulted by click handlers that
  // short-circuit their WS sends while paused (see Task 11).
  isPaused(): boolean;
}

export function mountRulesPauseBanner(): RulesPauseBannerHandle {
  const bar = document.getElementById('rules-pause-bar') as HTMLDivElement;
  const topicEl = document.getElementById('rules-pause-topic') as HTMLSpanElement;

  let topic: string | null = null;

  return {
    setPaused(t) {
      topic = t;
      bar.hidden = topic === null;
      topicEl.textContent = topic ?? '';
    },
    isPaused() {
      return topic !== null;
    },
  };
}
